/// <amd-module name="VSS/Fabric/Icons/Initialize" />

import { initializeIcons } from "./fabric-icons";

// TODO: Remove this once we've refactored all icons off of Office Fabric's <Icon /> component.

initializeIcons();

// Mark icons as initialized for the existing web platform not to initialize the icons again
(window as any).vssIconsInitialized = true;
